import mixins from 'synergycms_core/src/less/mixins';

export default {
  header: {},
  app: {
    backgroundColor: "rgba(0, 0, 0, 0)",
    height: '100%',
    position: 'relative',
    '& ul': {
      margin: 0,
      padding: 0,
      '& > li': {
        listStyle: 'none'
      }
    },
    '& input:focus': { outline: 'none' },
    '& select:focus': { outline: 'none' },
    '& textarea:focus': { outline: 'none' },
    '& button:focus': { outline: 'none' },
    '& $header': {
      textAlign: 'center',
      width: '100%',
      display: 'block',
      color: 'white',
      fontSize: '14px',
      zIndex: '60',
      margin: '0',
      boxSizing: 'border-box',
      position: 'relative',
      padding: '10px',
      backgroundColor: data => data.backgroundColor,
      '& h1': {
        margin: '5px 0 0 0'
      },
      '@media(min-width: 1001px)': {
        zIndex: 60
      },
      '&:lang(ar)':{
        direction:'rtl'
      }
    }
  },
  timeoutModalTable: {},
  timeoutModalTableCell: {},
  timeoutModalWhite: {},
  stastarModaldinfo: {},
  timeoutModalTitle: {
    display: "block",
    textTransform: "uppercase",
    fontWeight: "500",
    marginBottom: "36px",
    color: "#000",
  },
  stastarModaldquest: {},
  timeoutModalContent: {
    overflow: 'auto',
    font: "16px 'Roboto'",
    color: '#8c8c8c',
    background: 'rgba(0, 0, 0, 0.5)',
    position: 'fixed',
    left: '0',
    top: '0',
    right: '0',
    bottom: '0',
    zIndex: '500',
    '& $timeoutModalTable': {
      display: 'table',
      height: '100%',
      width: '100%',
      '& $timeoutModalTableCell': {
        display: 'table-cell',
        verticalAlign: 'middle',
        textAlign: 'center',
        padding: '20px'
      },
      '& $timeoutModalWhite': {
        padding: '40px 10px 13px 10px',
        margin: '0 auto',
        background: '#ffffff',
        top: '21%',
        textAlign: 'center',
        marginBottom: '10px',
        fontFamily: data => data.fontFamily1,
        '& svg': {
          fill: data => data.mainColor,
          width: '42px',
          height: '40px',
          '@media (min-width:601px)': {
            width: '70px',
            height: '70px',
            marginBottom: '35px'
          }
        },
        '& $timeoutModalTitle': {
          fontSize: '24px',
          fontWeight: '300',
          marginBottom: '35px'
        },
        '@media (min-width:601px)': {
          padding: '40px 90px 75px',
          maxWidth: '340px'
        }
      },
      '& $stastarModaldinfo': {
        fontSize: '13px',
        fontWeight: '300',
        color: '#000',
        padding: '0 15px 0',
        lineHeight: '1.38'
      },
      '& $stastarModaldquest': {
        verticalAlign: 'bottom',
        height: '40px'
      }
    }
  },
  timeoutModalLogo: {
    display: 'block',
    textTransform: 'uppercase',
    fontWeight: '500',
    marginBottom: '36px',
    color: '#000'
  },
  timeoutModalInfo: {
    display: 'block',
    fontSize: '16px',
    color: '#8c8c8c',
    fontWeight: 'normal',
    lineHeight: 'normal',
    paddingBottom: '20px',
    '&:last-of-type': {
      paddingBottom: '30px'
    }
  },
  sendMailContainer: {
    display: 'inline-block',
    verticalAlign: 'bottom',
    '& > div': {
      padding: '0 10px 0 0'
    },
    '& button': {
      padding: '0 15px',
      position: 'relative',
      height: '40px',
      width: '100%',
      ...mixins.boxSizing(),
      '@media(min-width: 601px)': {
        height: '50px'
      }
    }
  },
  backgroundContainerWhite: {
    '& > div': {
      background: '#fff',
      border: '1px solid #d8d8d8',
      borderBottom: 'none'
    },
    '& form': {
      backgroundColor: '#fff !important'
    }
  },
  buttonTextStyle: {
    fontFamily: 'inherit',
    fontStyle: 'unset',
    fontWeight: 'bolder'
  },
  customImageCode: {
    fontSize: '25px'
  },
  buttonStyle: {
    border: data => '1px solid ' + data.mainColor,
    color: data => data.mainColor,
    ...mixins.boxSizing('content-box'),
    textTransform: 'uppercase',
    cursor: 'pointer',
    textAlign: 'center',
    padding: '10px',
    marginRight: '15px',
    display: 'inline-flex',
    '&:hover': {
      backgroundColor: data => data.mainColor,
      ...mixins.transitionAll(),
      color: '#fff'
    }
  },
  textSendSelection: {
    padding: '6px'
  },
  timeoutModalButton: {
    paddingTop: '20px'
  },
  sendContainer: {
    display: 'table-cell',
    verticalAlign: 'middle',
    '& > div': {
      padding: '0 15px 0 0',
      '& > button': {
        width: '175px',
        padding: '13px 0'
      }
    }
  },
  sendRequest: {
    color: data => data.mainColor,
    display: 'block',
    marginTop: '20px',
    fontSize: '13px'
  }
};
